import { Props } from '../../native';
import Comment from '../../../sub/comment';
import * as React from 'react';
import { NativeTransparencyButton } from '../../parts/native-transparency-button';
import Description from '../../../sub/description';

/**
 * Not yet implemented with Fabric. Using old troika...
 * @param props
 * @constructor
 */
export const ResultPrepackageAd = (props: Props) => {
    const { id, adObj, deviceType, accessibilityId } = props;
    const { native } = adObj;
    const mobile = deviceType === 'mobile';

    const desktopHeight = mobile ? {} : { minHeight: 170 };
    return (
        <div
            id={id}
            style={desktopHeight}
            aria-owns={accessibilityId}
            className={`grid ads__unit skeleton-screen u-pa2`}
        >
            <Comment placement="ResultPrepackageAd" adObj={adObj} />
            <div
                className={`grid__unit u-r-size2of5 u-m-ph16 ${
                    mobile ? '' : 'u-mv16'
                }`}
            >
                <div className={`ads ads--liquid ads--liquid--cols1to1 u-ma0`}>
                    <div className={`ads__unit__img ads__img_mobile`}>
                        <div
                            className={`img-format img-format--centered img-format--crop-horizontal overlay__item_1`}
                            style={{
                                aspectRatio: '4/3',
                            }}
                        >
                            <img
                                className={`image-frame center-cropped`}
                                alt={'Annonsebilde'}
                                src={native?.image?.url}
                                style={{ objectFit: 'cover', height: '100%' }}
                            />

                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    padding: '4px 8px',
                                    background: '#e5e5e5',
                                    borderRadius: '8px 0',
                                    fontSize: 12,
                                }}
                            >
                                Annonse
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`grid__unit u-r-size3of5 u-m-ph16 u-mt0`}>
                <div className={`u-mt32 u-hide-lt900`} />

                <div className={'u-d1 u-stone'}>{native.sponsoredBy}</div>
                <h2
                    id="ad-title-416457018"
                    className="u-b1 u-ma0 u-truncate"
                    style={{ fontWeight: 'bold' }}
                >
                    {/*TODO: Anchor here does not fill the image */}
                    <a
                        id={accessibilityId}
                        href={native.clickUrl}
                        title={native.title}
                        rel="noreferrer"
                        target="_blank"
                        className="da-no-underline focus-ring"
                    >
                        <span
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                            }}
                            aria-hidden="true"
                        ></span>
                        <span
                            className="text-gray-700"
                            style={{ color: '#464646' }}
                        >
                            {native.title}
                        </span>
                    </a>
                </h2>

                <Description native={native} className="text-14" />
                <div
                    style={{ position: 'absolute', bottom: 8, right: 8 }}
                    className={'absolute bottom-8 right-8'}
                ></div>
            </div>
            <NativeTransparencyButton adObj={adObj} />
        </div>
    );
};
